export default __webpack_public_path__ + "static/media/paymentChecked.5fc68384.svg";